<template>
    <div class="search-box">
        <form @submit.prevent="handleSubmit" class="search__form">
            <span v-if="showMinLetterWarning">
                {{ $t('Search box must contain at least three letters') | capitalize }}
            </span>
            <AutoCompleteInput
                v-model="query"
                @click="showSuggestions"
                @itemClick="handleSubmit"
                @suggestionsStateChange="onSuggestionsStateChange"
                :placeholder="$t('search events') | capitalize"
                :areSuggestionsShown="areSuggestionsShown"
                :results="suggestions"
                :minCharacters="3"
                :isAsync="true"
                type="text"
                data-lpignore="true"
            />
        </form>
    </div>
</template>

<script>
    const minCharacters = 3;

    export default {
        name: 'SearchInput',
        props: {
            suggestionsFunction: {
                type: Function,
                required: true,
            },
            predefinedSuggestions: {
                type: Array,
                default: () => [],
            }
        },
        data() {
            return {
                query: '',
                suggestions: [],
                areSuggestionsShown: false,
                minCharacters,
                showMinLetterWarning: false
            };
        },
        methods: {
            handleSubmit() {
                if (this.query.trim().length >= this.minCharacters) {
                    this.$emit('submit', this.query);
                } else {
                    this.showMinLetterWarning = true;
                }
            },
            showSuggestions() {
                this.areSuggestionsShown = true;
                this.suggestions = this.predefinedSuggestions;
            },
            onSuggestionsStateChange(value) {
                this.areSuggestionsShown = value;
            }
        },
        watch: {
            query(newValue) {
                if (newValue.trim().length >= minCharacters) {
                    this.showMinLetterWarning = false;
                    this.suggestions = this.suggestionsFunction(this.query);
                } else {
                    this.suggestions = this.predefinedSuggestions;
                }
            }
        }
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/app/modules/sportOffer/sharedSubmodules/SearchInput.vue